import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import {
     Department,
    SchoolWorkloadConfig,
} from "../../../models/SchoolWorkloadConfig";
import ApiService from "../../ApiService";
import * as _ from "lodash";
import EditableCard from "./EditableCard";
import {ActionButton,  MessageBarType} from "office-ui-fabric-react";
import School from "../../../models/School";

interface OnboardDepartmentPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: History;
}

interface OnboardDepartmentPageState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    departments: Department[];
}

class OnboardDepartmentPage extends Component<OnboardDepartmentPageProps & DispatchProps, OnboardDepartmentPageState> {

    constructor(props: OnboardDepartmentPageProps & DispatchProps) {
        super(props);
        this.state = {
            schoolWorkloadConfig: undefined,
            departments: []
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId)
        {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
            this.setState({
                schoolWorkloadConfig
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardDepartmentPageProps & DispatchProps>, prevState: OnboardDepartmentPageState): Promise<void> {
        if(this.state.schoolWorkloadConfig !== prevState.schoolWorkloadConfig) {

            const departments = _.cloneDeep(this.state.schoolWorkloadConfig?.departments?.items || []);
            this.setState({
                departments: _.sortBy(departments,['rawName'])
            });
        }
    }

    private onRename = (departmentToRename: Department, newName: string): void => {

        const renamedDepartment = _.cloneDeep(departmentToRename);
        renamedDepartment.rawName = newName;
        
        const newItems = _.clone(this.state.departments);
        const existingIndex = this.state.departments.indexOf(departmentToRename);

        newItems.splice(existingIndex,1,renamedDepartment);
        
        this.setState({
            departments: newItems
        });
    };

    private onDelete = (departmentToDelete: Department): void => {

        this.setState({
            departments: _.without(this.state.departments,departmentToDelete)
        });
    }

    private onAdd = (): void  => {

        const newItem = {rawName: ""} as Department
        const departments = [...this.state.departments,newItem];

        this.setState({
            departments
        });
    }
    
    private save = async (): Promise<boolean> => {
        if(this.state.schoolWorkloadConfig === undefined) {
            return false;
        }

        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);
        
        updatedConfig.departments.items = this.state.departments;

        const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId,this.props.schoolCode,updatedConfig);

        this.setState({
            schoolWorkloadConfig: savedSchoolWorkloadConfig
        });

        await this.props.dispatch(Actions.showMessageBar("Saved departments to config",MessageBarType.success));

        return true;
    }

    public render(): JSX.Element {

        const departmentCards = this.state.departments.map(department => {
            return (
                <EditableCard
                    key={department.rawName}
                    item={department}
                    namePropertyName={"rawName"}
                    onRename={this.onRename}
                    onDelete={this.onDelete}
                >
                </EditableCard>
            );
        });

        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"department"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="onboard-timeline-content">
                                    <div className="flex-item--flex-1 flex-column flex--align-items-center">

                                        <h3>Departments</h3>
                                        {departmentCards}

                                        <ActionButton
                                            className={"m-top-05rem"}
                                            iconProps={{iconName: "Add"}}
                                            text="Add Department"
                                            disabled={false}
                                            checked={false}
                                            onClick={this.onAdd}
                                        />
                                    </div>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"department"} timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={true} enableSave={true} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardDepartmentPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardDepartmentPage)